import React, {Fragment} from 'react'
import PropTypes from 'prop-types'

import QuestionFreitext from './QuestionFreitext'
import QuestionMultipleFreitext from './QuestionMultipleFreitext'
import QuestionSingleChoice from './QuestionSingleChoice'
import QuestionMultipleChoice from './QuestionMultipleChoice'
import QuestionImageUpload from './QuestionImageUpload'
import QuestionReference from './QuestionReference'
import QuestionTable from './QuestionTable'
import Text from '#components/a/Text'

class Question extends React.Component {
  renderQuestion = question => {
    const {chapterId, isReadOnly, setHasUnsavedChanges} = this.props
    const {id} = this.props.question

    const questionProps = {
      chapterId,
      questionId: id,
      question,
      isReadOnly,
    }

    switch (question.questionType) {
      case 'text':
        return <QuestionFreitext {...questionProps} setHasUnsavedChanges={setHasUnsavedChanges} />
      case 'text_ma':
        return <QuestionMultipleFreitext {...questionProps} setHasUnsavedChanges={setHasUnsavedChanges} />
      case 'sc':
        return <QuestionSingleChoice {...questionProps} />
      case 'mc':
        return <QuestionMultipleChoice {...questionProps} />
      case 'img':
        return <QuestionImageUpload {...questionProps} />
      case 'ref':
        return <QuestionReference {...questionProps} />
      case 'table':
        return <QuestionTable {...questionProps} setHasUnsavedChanges={setHasUnsavedChanges} />
      default:
        return (
          <div>
            <Text text={question.text} />
          </div>
        )
    }
  }

  render() {
    const {question} = this.props
    return <>{this.renderQuestion(question)}</>
  }
}

Question.propTypes = {
  question: PropTypes.object.isRequired,
  chapterId: PropTypes.string.isRequired,
  questionId: PropTypes.string,
  isReadOnly: PropTypes.bool.isRequired,
  setHasUnsavedChanges: PropTypes.func.isRequired,
}

export default Question
